module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    attrs: {
      "id": "footer-bar"
    }
  }, [_c('svg', {
    staticClass: "navbar-svg footer-pos",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "9012 -942 50 40.417"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(9012 -942)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M79.436,26.993,76.025,2.634A3.127,3.127,0,0,0,73.012,0H38.369a2.385,2.385,0,0,0-2.4,2.779l3.41,24.359a3.14,3.14,0,0,0,3,2.634H77.018a2.377,2.377,0,0,0,1.84-.812A2.474,2.474,0,0,0,79.436,26.993Zm-1.371,1.245a1.337,1.337,0,0,1-1.028.451H42.392a2.039,2.039,0,0,1-1.931-1.7L37.052,2.634a1.382,1.382,0,0,1,.307-1.1,1.3,1.3,0,0,1,1.01-.451H73.012a2.039,2.039,0,0,1,1.931,1.7l3.41,24.359A1.355,1.355,0,0,1,78.064,28.238Z",
      "transform": "translate(-29.457)"
    }
  }), _c('path', {
    attrs: {
      "d": "M39,48.975a2.209,2.209,0,0,1-.577,1.263,1.709,1.709,0,0,1-1.137.451H2.642a1.518,1.518,0,0,1-1.516-1.7L3.8,24.634a1.782,1.782,0,0,1,.577-1.1,1.709,1.709,0,0,1,1.137-.451h.451L5.781,22a3.041,3.041,0,0,0-2.039.812A3.04,3.04,0,0,0,2.7,24.779L.026,49.137a2.326,2.326,0,0,0,2.346,2.634h13.8v3.446c0,.812,0,1.516-.271,1.786a.928.928,0,0,1-.379.18H11.3a.632.632,0,1,0,0,1.263H26.91a.632.632,0,0,0,0-1.263H22.688a.746.746,0,0,1-.379-.18c-.271-.271-.271-.974-.271-1.786V51.772H37.015a3.041,3.041,0,0,0,2.039-.812,3.219,3.219,0,0,0,1.028-1.8c0-.036.018-.072.018-.108V48.7H39Zm-21.778,8.21a6.005,6.005,0,0,0,.2-1.967V51.772h3.338v3.446a6,6,0,0,0,.2,1.967Z",
      "transform": "translate(-0.009 -18.03)"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer-menu"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/miscellanous/conditions-utilisation"
    }
  }, [_vm._v("Conditions d'utilisation")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto: votre-espace.adgency@orisha.com",
      "target": "_blank"
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/miscellanous/conseils-pratiques"
    }
  }, [_vm._v("Conseils pratiques")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/miscellanous/mentions-legales"
    }
  }, [_vm._v("Mentions obligatoires")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d4d4b92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d4d4b92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 198
// module chunks = 1